import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DateTransform } from '@app/shared/utils/date.transform';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: { TimeZoneId: DateTransform.zone }
    });

    return next.handle(request);
  }
}
